define([
    "angular"
], function () {

    return angular.module("monitoringIntegrationModule", [])
})